import React from "react";
import { Flame } from "lucide-react";
import { useLang } from "../i18n/LanguageContext";

const tier = (n) => (n >= 6 ? "bg-crimson text-white" : n >= 3 ? "bg-gold text-crimson" : "bg-palm/15 text-palm");

export function StreakBadge({ streak, compact = false }) {
  const { t } = useLang();
  if (!streak) return null;
  const n = streak.current;
  if (n === 0) {
    return compact ? null : (
      <p className="mt-2 text-xs text-muted-foreground" data-testid="streak-empty">
        {t("Attend the next General Meeting to start a streak")}{streak.best > 0 ? ` · ${t("best")}: ${streak.best}` : ""}
      </p>
    );
  }
  return (
    <span className={`inline-flex items-center gap-1 rounded-full px-2.5 py-1 text-xs font-semibold ${tier(n)} ${compact ? "" : "mt-2"}`}
      title={`${t("Best streak")}: ${streak.best}`} data-testid="streak-badge">
      <Flame size={13} className={n >= 3 ? "animate-pulse" : ""} />
      {n} {t(n === 1 ? "meeting in a row" : "meetings in a row")}
      {n === streak.best && n >= 2 && <span className="ml-1 rounded-full bg-white/30 px-1.5 text-[10px] uppercase tracking-wider">{t("best")}</span>}
    </span>
  );
}
